import { SOCIAL_PLATFORMS } from 'ui-components';
import { PlayYoutubeIcon } from '~/components/icons';
import { YT_ASPECT_RATIO } from '~/constants';
import { CreatorBenchmarks, YoutubeType } from '~/types';
import { formatAbbr } from '~/utils';

import { getContentLink } from '../../MediaPackDetailDefaultScreen.helpers';
import { PLATFORM_METRICS } from '../MediaPackDetailEditHighlightsModal/MediaPackDetailEditHighlightsModal.constants';
import { mapMetricsToMetricCardData } from '../MediaPacksDefaultTemplate/OverviewSection/OverviewSection.mapper';

type YoutubeProps = {
  hasManager?: boolean;
  ytContents: YoutubeType[];
  isSharedView?: boolean;
};

export const mapYoutubeContentToHighlightedContentProps = ({
  hasManager,
  ytContents,
  isSharedView,
}: YoutubeProps) =>
  ytContents.map((ytContent) => ({
    aspectRatio: YT_ASPECT_RATIO,
    contentFooter: [
      {
        icon: PlayYoutubeIcon,
        label: `${formatAbbr(ytContent.viewCount)} Views`,
      },
    ],
    contentId: ytContent.id,
    link: getContentLink({
      hasManager,
      id: ytContent.id,
      isSharedView,
      platform: SOCIAL_PLATFORMS.youtube,
      shareLink: ytContent.shareLink,
    }),
    contentSrc: ytContent.thumbnails.high.url,
  }));

export const mapYoutubeMetricsToMetricCardData = (
  metrics: string[],
  creatorBenchmarks: CreatorBenchmarks,
) =>
  mapMetricsToMetricCardData(
    metrics,
    PLATFORM_METRICS.youtube,
    creatorBenchmarks,
  );
